import React, {Component} from 'react';
import {
    Button,
    Form,
    Container,
    Header, Grid
} from 'semantic-ui-react';
import update from 'react-addons-update';

import StoreData from "../../data/StoreData";
import CategoryData from "../../data/CategoryData";
import {showToast} from "../../actions/ToastAction";
import {connect} from "react-redux";
import resources from "../../data/resources";
import Loading from "../extras/Loading";

const c = require("../../constants");

class OurForm extends Component {

    constructor() {
        super();

        this.state = {
            categories: [],
            regimes: c.REGIME_TYPES,
            store: {
                name: "",
                nit: '',
                profile: {
                    slogan: "",
                    email: ""
                }
            },
            category_error: false,
            name_error: false,
            nit_error: false,
            email_error: false,
            description_error: false,
            disabled_button: false,
            loading: true
        };

        this.handleNameChange = this.handleNameChange.bind(this);
        this.handleNitChange = this.handleNitChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleSloganChange = this.handleSloganChange.bind(this);
        this.handleEmailChange = this.handleEmailChange.bind(this);
    }

    componentDidMount() {
        this.initialFetch();
    }

    async handleSubmit(event) {
        event.preventDefault();
        if (this.state.store.name === "") {
            this.setState({name_error: false});
        } else if (this.state.store.nit === '') {
            this.setState({nit_error: true});
        }else if (this.state.store.profile.slogan === '') {
            this.setState({slogan_error: true});
        } else if (this.state.store.profile.email === '' || !resources.validators.isValidEmailAddress(this.state.store.profile.email)) {
            this.setState({email_error: true});
        } else {
            this.setState({disabled_button: true});
            StoreData.updateInformation(this.state.store, (res) => {
                if (res.update) {
                    this.props.showToast({message:'Información Actualizada!', type:'success'});
                } else {
                    this.props.showToast({message:'Tenemos un problema, inténtalo más tarde!', type:'error'});
                }
                this.setState({disabled_button: false});
            });
        }
    }

    handleCategoryChange = (result) => {
        let name = update(this.state, {
            store: {
                category: {
                    key: {$set: result},
                    value: {$set: result}
                }
            }
        });
        this.setState(name);
        this.setState({category_error: false})
    };

    handleRegimeChange = (result) => {
        let regime = update(this.state, {
            store: {
                regime: {$set: result}
            }
        });
        this.setState(regime);
    };

    handleNameChange(event) {
        let data = update(this.state, {
            store: {
                name: {
                    $set: event.target.value
                }
            }
        });
        this.setState(data);
        if (event.target.value.trim() === '') {
            this.setState({name_error: true});
        } else {
            this.setState({name_error: false});
        }
    };

    handleNitChange(event) {
        let data = update(this.state, {
            store: {
                nit: {
                    $set: event.target.value
                }
            }
        });
        this.setState(data);
        if (event.target.value.trim() === '') {
            this.setState({nit_error: true});
        } else {
            this.setState({nit_error: false});
        }
    };

    handleSloganChange(event) {
        let slogan = update(this.state, {
            store: {
                profile: {
                    slogan: {
                        $set: event.target.value
                    }
                }
            }
        });
        this.setState(slogan);
        if (event.target.value.trim() === '') {
            this.setState({slogan_error: true});
        } else {
            this.setState({slogan_error: false});
        }
    }

    handleEmailChange(event) {
        let email = update(this.state, {
            store: {
                profile: {
                    email: {
                        $set: event.target.value
                    }
                }
            }
        });
        this.setState(email);
        if (event.target.value.trim() === '' || !resources.validators.isValidEmailAddress(event.target.value)) {
            this.setState({email_error: true});
        } else {
            this.setState({email_error: false});
        }
    }

    async initialFetch() {
        const [categories, store] = await Promise.all([
            CategoryData.list(),
            StoreData.getInformation()
        ]);
        if(!store.hasOwnProperty('detail')){
            store.category = store.category ? store.category : {key: '', value: ''};
            this.setState({categories, store, loading:false});
        }
    }

    render() {
        return (
            <Container>
                <Header as='h2'>
                    <Header.Content>
                        Información de tu Negocio
                    </Header.Content>
                </Header>
                {this.state.loading ? <Loading/>:
                    <Form onSubmit={this.handleSubmit}>
                        <Grid>
                            <Grid.Row>
                                <Grid.Column mobile={16} computer={8}>
                                    <Form.Input label='Nombre del Negocio' placeholder='Nombre del Negocio'
                                                value={this.state.store.name} onChange={this.handleNameChange}
                                                error={this.state.name_error}/>
                                    <Form.Select label='Régimen' options={this.state.regimes}
                                                 value={this.state.store.regime}
                                                 onChange={(e, {value}) => this.handleRegimeChange(value)} placeholder='Régimen'
                                                 error={this.state.category_error}/>
                                    <Form.Input label='NIT' placeholder='NIT' value={this.state.store.nit}
                                                onChange={this.handleNitChange} error={this.state.nit_error}/>
                                </Grid.Column>
                                <Grid.Column mobile={16} computer={8}>
                                    <Form.Input label='Slogan' placeholder='Slogan' value={this.state.store.profile.slogan}
                                                onChange={this.handleSloganChange} error={this.state.slogan_error}/>
                                    <Form.Input label='Email' placeholder='Email' value={this.state.store.profile.email}
                                                onChange={this.handleEmailChange} error={this.state.email_error}/>
                                </Grid.Column>
                            </Grid.Row>
                            <Grid.Row>
                                <Grid.Column>
                                    <Button primary fluid disabled={this.state.disabled_button} loading={this.state.disabled_button}
                                            type="submit" content="Actualizar Información"/>
                                </Grid.Column>
                            </Grid.Row>
                        </Grid>
                    </Form>}
            </Container>
        );
    }
}

function mapDispatchToProps(dispatch){
    return {
        showToast(toast){
            dispatch(showToast(toast))
        }
    }
}

export default connect(
    null,
    mapDispatchToProps
)(OurForm)


// WEBPACK FOOTER //
// ./src/components/settings/OurForm.js